import { Box, Button, Flex, Select, Tooltip, useToast } from '@chakra-ui/react';
import Disclamer from 'components/atoms/Disclamer';
import { useTranslation } from 'helpers/languages/translations';
import { tableToolbarStyle } from 'shared/styles';
import { TFacultativeTabProps } from '../FacultativeContainer';

const FacultativeTabToolbar = ({
    allRetailers,
    hasChanges,
    addSelectedRetailer,
    handleUpdateFacByRetailer,
}: TFacultativeTabProps) => {
    const translate = useTranslation();
    const toast = useToast();

    const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
        addSelectedRetailer(Number(e.target.value));
        toast({
            title: translate('splits.tab.facultative.added'),
            status: 'success',
            isClosable: true,
            duration: 1000,
        });
    };

    return (
        <Flex {...tableToolbarStyle} alignItems="center">
            <Button colorScheme="blue" onClick={handleUpdateFacByRetailer} isDisabled={!hasChanges} mr={3} size="sm">
                {translate('splits.tab.facultative.save')}
            </Button>
            <Box flexGrow={0} mr={3}>
                <Tooltip label={translate('splits.tab.facultative.btnAddTip')}>
                    <Select size="sm" onChange={handleChange} value="">
                        <option value="">{translate('splits.tab.facultative.btnAddPlaceholder')}</option>
                        {allRetailers.map((retailer) => (
                            <option key={retailer.id} value={retailer.id}>
                                {retailer.name}
                            </option>
                        ))}
                    </Select>
                </Tooltip>
            </Box>
            {hasChanges && (
                <Disclamer status="warning" body={translate('splits.tab.facultative.disclamer')} flexGrow={0} />
            )}
        </Flex>
    );
};

export default FacultativeTabToolbar;
